import { render, staticRenderFns } from "./IDForgot.vue?vue&type=template&id=b450b2cc&scoped=true"
import script from "./IDForgot.vue?vue&type=script&lang=js"
export * from "./IDForgot.vue?vue&type=script&lang=js"
import style0 from "./IDForgot.vue?vue&type=style&index=0&id=b450b2cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450b2cc",
  null
  
)

export default component.exports